export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11429.a1b771c8.jpg";